module.exports = __webpack_public_path__ + "static/media/student39.62eb293a.png";